<template>
	<div>
		<el-form ref="ruleForm" :inline="true" :model="ruleForm" :rules="rules" class="demo-form-inline">
      <el-form-item v-for="(item,index) in searchLists" :key="index" :label="item.label" :prop="item.name">
        <template v-if="item.type == 'text'">
					<el-input v-model="ruleForm[item.name]" :placeholder="item.placeholder"></el-input>
				</template>
				<template v-else-if="item.type == 'select'">
					<el-select v-model="ruleForm[item.name]" :placeholder="item.placeholder">
						<el-option v-for="(e,i) in item.options" :key="i" :label="e.label" :value="e.value"></el-option>
					</el-select>
				</template>
      </el-form-item>
      <el-form-item>
				<!-- @click="onSubmit" -->
        <el-button @click="submit('ruleForm')" type="primary">查询</el-button>
      </el-form-item>
    </el-form>
	</div>
</template>
<script>
	export default {
		name: "Search",
		props: {
			searchLists: Array,
			ruleForm: {
				type: Object,
				default: () => ({})
			},
			rules: {
				type: Object,
				default: () => ({})
			},
		},
		data() {
			return {
			}
		},
		mounted() {
		},
		methods: {
			submit(formName) {
				let _this = this
        this.$refs[formName].validate((valid) => {
          if (valid) {
						this.$parent.submitForm();
						// _this.$emit('submitForm',_this.ruleForm);
						console.log('子组件', _this.ruleForm)
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
			changeSystem(){
				console.log(this.value)
			},
		},
	};
</script>
<style lang="less">
</style>